import i18next from 'i18next'

import de from './resources/de'
import fr from './resources/fr'
import it from './resources/it'
import en from './resources/en'

export const defaultLanguage = 'de'
export const allowedLanguages = ['en', 'de', 'fr', 'it']

i18next
    .init({
        // eslint-disable-next-line no-undef
        debug: (process.env.NODE_ENV === 'development'),
        lng: defaultLanguage,
        fallbackLng: defaultLanguage,
        whitelist: allowedLanguages,
        defaultNS: 'general',
        resources: {
            de,
            fr,
            it,
            en
        }
    })

export default i18next
